(function () {
  // console.log("event-page.js ready");
  const eventUpdateInterval = 10000;

  const updateTabPanels = (navTabs, tabPanels, tab) => {
    // Remove 'aria-selected' attribute from all tabs
    for (const t of navTabs) {
      t.setAttribute("aria-selected", "false");
    }

    // Add 'aria-selected="true"' to the clicked tab
    tab.setAttribute("aria-selected", "true");

    // Hide all tab panels
    for (const p of tabPanels) p.hidden = true;

    // Show the corresponding tab panel
    const targetPanelId = tab.id.replace(/tab_/g, "panel_");
    const targetPanel = document.getElementById(targetPanelId);
    if (targetPanel) targetPanel.hidden = false;
  };

  const startCountdown = () => {
    const counter = document.getElementById("event-countdown-time");
    const title = document.getElementById("event-countdown-title");

    let diff = counter.dataset.timestampDiff * 1000;
    const padNumber = (n) => (n < 10 ? "0" + n : n);

    const updateCounter = (diff) => {
      const t = diff;
      const days = Math.floor(t / (1000 * 60 * 60 * 24));
      const hours = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((t % (1000 * 60)) / 1000);

      counter.textContent = `${days ? days + "d " : ""}${padNumber(
        hours
      )}:${padNumber(minutes)}:${padNumber(seconds)}`;
    };

    updateCounter(diff);

    const countdownTimer = setInterval(() => {
      if (diff <= 0) {
        clearInterval(countdownTimer);
        counter.textContent = "00:00:00";
        title.textContent = "Kamp nu live";
        return;
      }
      diff = diff - 1000;
      updateCounter(diff);
    }, 1000);
  };

  const getEvent = async (eventID) => {
    try {
      const url = "/ajax/get_events_json.php?id=" + eventID;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) throw new Error("Failed to fetch Event");

      return await response.json();
    } catch (error) {
      console.error("Error: ", error);
    }
  };

  const getIncidents = async (eventID) => {
    try {
      const url = "/ajax/get_events_html.php?id=" + eventID + "&mode=incidents";
      const response = await fetch(url, {
        method: "GET",
      });

      if (!response.ok) throw new Error("Failed to fetch Event Incidents");

      return await response.text();
    } catch (error) {
      console.error("Error: ", error);
    }
  };

  const updateEventTimeline = (html) => {
    const timeline = document.getElementById("event-timeline");
    if (timeline) timeline.innerHTML = html;
  };

  const updateEventChunks = (event) => {
    // Update score
    const score = document.getElementById("event_score");
    const scoreHome = document.getElementById("event_score_home");
    const scoreAway = document.getElementById("event_score_away");
    score.dataset.status = event.status_type;
    scoreHome.innerHTML = event.home_score;
    scoreAway.innerHTML = event.away_score;

    // Update gameclock
    const gameclock = document.getElementById("event_gameclock");
    const gameclockText = document.getElementById("event_gameclock_text");
    gameclock.dataset.status = event.status_type;
    gameclockText.innerHTML = event.gameclock;
  };

  const updateEventStats = (event) => {
    const statsNames = [
      "possession",
      "shoton",
      "shotoff",
      "corner",
      "offside",
      "yellow_cards",
      "red_cards",
      "foulcommit",
      "throwin",
      "subst",
    ];

    for (const s of statsNames) {
      const record = document.getElementById("stats_" + s);
      if (!record) continue;

      const key1 = "stats_" + s + "_p1";
      const key2 = "stats_" + s + "_p2";
      const key1pct = "stats_" + s + "_p1_pct";

      if (!event[key1] || !event[key2] || !event[key1pct]) {
        // Hide the record if no data
        record.hidden = true;
        continue;
      }

      // Show the record
      record.hidden = false;

      const p1 = document.getElementById(key1);
      const p2 = document.getElementById(key2);
      const p1Pct = document.getElementById(key1pct);
      const suffix = s === "possession" ? "%" : "";

      p1.innerHTML = event[key1] + suffix;
      p2.innerHTML = event[key2] + suffix;
      p1Pct.style.width = event[key1pct];
    }

    // Update shots
    const on1 = document.getElementById("shot_stats_shoton_p1");
    const on2 = document.getElementById("shot_stats_shoton_p2");
    const off1 = document.getElementById("shot_stats_shotoff_p1");
    const off2 = document.getElementById("shot_stats_shotoff_p2");

    if (on1 && on2 && off1 && off2) {
      on1.innerHTML = event.stats_shoton_p1 ?? "0";
      on2.innerHTML = event.stats_shoton_p2 ?? "0";
      off1.innerHTML = event.stats_shotoff_p1 ?? "0";
      off2.innerHTML = event.stats_shotoff_p2 ?? "0";
    }
  };

  const updateEvent = (eventID) => {
    setTimeout(async () => {
      const [eventsArray, incidents] = await Promise.allSettled([
        getEvent(eventID),
        getIncidents(eventID),
      ]);

      if (!eventsArray.value || !incidents.value) return;
      const event = eventsArray.value[0];

      // Update timeline
      updateEventTimeline(incidents.value);

      // Update minor event elements
      updateEventChunks(event);

      // Update event stats
      updateEventStats(event);

      if (event.status_type === "inprogress") updateEvent(eventID);
    }, eventUpdateInterval);
  };

  document.addEventListener("DOMContentLoaded", () => {
    const dialog = document.getElementById("event_dialog");
    if (!dialog) return;

    const eventID = dialog.dataset.eventId;
    const eventStatus = dialog.dataset.eventStatus;

    // Get all tabs and tab panels
    const navTabs = document.querySelectorAll("[data-event-nav-item]");
    const tabPanels = document.querySelectorAll("[data-event-tabpanel]");

    if (navTabs.length > 0 && tabPanels.length > 0) {
      for (const tab of navTabs) {
        tab.addEventListener("click", (e) => {
          e.preventDefault();
          updateTabPanels(navTabs, tabPanels, tab);
        });
      }
    }

    // Countdown timer
    const countdown = document.getElementById("event-countdown");
    if (countdown) startCountdown();

    // Start updating the event
    if (eventStatus === "inprogress") updateEvent(eventID);
  });
})();
